import { render, staticRenderFns } from "./AuditFormSectionHeader.vue?vue&type=template&id=f631d7f4&scoped=true&"
import script from "./AuditFormSectionHeader.vue?vue&type=script&lang=js&"
export * from "./AuditFormSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./AuditFormSectionHeader.vue?vue&type=style&index=0&id=f631d7f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f631d7f4",
  null
  
)

export default component.exports